/* eslint-disable no-underscore-dangle */
// loaclStorage 本地存储扩展
const { localStorage } = window;

const oldGetItem = localStorage.getItem.bind(localStorage);
const oldSetItem = localStorage.setItem.bind(localStorage);
const oldRemoveItem = localStorage.removeItem.bind(localStorage);
const oldClear = localStorage.clear.bind(localStorage);

function noUse() {
  console.error('localstorage请使用公共库app.ls调用');
}

Object.getPrototypeOf(localStorage)._getItem = oldGetItem;
Object.getPrototypeOf(localStorage)._setItem = oldSetItem;
Object.getPrototypeOf(localStorage)._removeItem = oldRemoveItem;
Object.getPrototypeOf(localStorage)._clear = oldClear;

localStorage.getItem = noUse;
localStorage.setItem = noUse;
localStorage.removeItem = noUse;
localStorage.clear = noUse;

function setItem(key, value) {
  let v = value;
  // if (typeof v === 'string') {
  //   v = `str-${v}`;
  // } else if (typeof v === 'object') {
  //   v = JSON.stringify(v);
  //   v = `obj-${v}`;
  // } else {
  //   throw new Error('参数错误...');
  // }
  if (typeof v === 'string') {
    v = `str-${v}`;
  } else {
    v = JSON.stringify(v);
    v = `obj-${v}`;
  }
  oldSetItem(key, v);
}

function getItem(key) {
  let v = oldGetItem(key);
  if (v) {
    if (v.indexOf('obj-') === 0) {
      v = v.slice(4);
      return JSON.parse(v);
    }
    if (v.indexOf('str-') === 0) {
      return v.slice(4);
    }
  }
  return null;
}

export default {
  getItem,
  setItem,
  removeItem: oldRemoveItem,
};
